import React from 'react';
import { useTranslation } from 'react-i18next';
import { useShop } from '../../context/ShopContext';
import QuickActions from '../../components/dashboard/QuickActions';
import { generateShopUrl } from '../../utils/urlUtils';

const OverviewTab = ({ onNavigateMenu, onNavigateTables, onNavigateBaristas, onNavigateOrders, onViewPublicMenu }) => {
  const { t } = useTranslation();
  const { products, tables, shop } = useShop();
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="card">
          <h3 className="text-xl font-semibold text-white mb-2">{t('dashboard.totalProducts')}</h3>
          <p className="text-3xl font-bold text-[#a15507]">{products?.length || 0}</p>
        </div>
        <div className="card">
          <h3 className="text-xl font-semibold text-white mb-2">{t('dashboard.activeTables')}</h3>
          <p className="text-3xl font-bold text-[#a15507]">{tables?.length || 0}</p>
        </div>
        <div className="card">
          <h3 className="text-xl font-semibold text-white mb-2">{t('dashboard.shopUrl')}</h3>
          <p className="text-[#a15507] break-all">{generateShopUrl(shop?.slug || 'loading')}</p>
        </div>
      </div>
      <QuickActions
        onAddProduct={onNavigateMenu}
        onGenerateQR={onNavigateTables}
        onAddBarista={onNavigateBaristas}
        onViewOrders={onNavigateOrders}
        onViewPublicMenu={onViewPublicMenu}
      />
    </div>
  );
};

export default OverviewTab;
